import React, { useEffect, useRef } from "react";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";

const TranscriptComponent = ({
  updateFormField,
  textareaRef,
  isBackgroundListen = false,
  listenAudio = false,
  clearLength,
  updateDatainFireBase,
  TransText,
}) => {
  const meetingManager = useMeetingManager();
  const newTranscripts = useRef("");
  const lastTranscriptionText = useRef("");
  function updateData() {
    if (newTranscripts.current) {
      updateFormField(newTranscripts.current);
      updateDatainFireBase();
      newTranscripts.current = "";
    }
  }
  const listenTranscript = () => {
    const audioVideo = meetingManager.audioVideo;
    if (audioVideo && audioVideo.transcriptionController) {
      meetingManager.audioVideo.transcriptionController?.subscribeToTranscriptEvent(
        (transcriptEvent) => {
          const transcriptResults = transcriptEvent?.results || [];
          // console.log("transcriptResults",transcriptResults)
          if (transcriptResults.length === 0) {
            updateData();
            // return;
          } else {
            transcriptResults.forEach((result, index) => {
              if (!result.isPartial) {
                const transcriptionText = result.alternatives[0].transcript;
                if (transcriptionText !== lastTranscriptionText.current) {
                  newTranscripts.current =
                    newTranscripts.current + " " + transcriptionText;
                  lastTranscriptionText.current = transcriptionText;
                  console.log(index, "transcriptionText: ", transcriptionText);
                  TransText(transcriptionText);
                  if (newTranscripts.current.length > 60) {
                    updateData();
                  }
                }
              }
            });
          }
        }
      );
    }
  };

  const removeTranscript = () => {
    const audioVideo = meetingManager.audioVideo;
    if (audioVideo && audioVideo.transcriptionController) {
      audioVideo.transcriptionController.unsubscribeFromTranscriptEvent();
    }
  };
  useEffect(() => {
    listenTranscript();

    return () => {
      removeTranscript();
    };
  }, [meetingManager]);

  // useEffect(() => {
  //   const interval = setInterval(updateData, 15000);

  //   return () => clearInterval(interval);
  // }, [updateDatainFireBase]);

  return <></>;
};

export default TranscriptComponent;
